module.exports = {
  google: {
    API_KEY: "AIzaSyA6H8OPr2aI8teDW091uMyCaBlVEN_4FPU",
    CLIENT_ID: "394495840870-g54o2pols01rjpgp4o3ag4iatm9amnpl.apps.googleusercontent.com",
    SECRET: "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",
  },
  facebook: {
    APP_ID: "blops_leads_dev",
  },
}